import { render, staticRenderFns } from "./fpFooter.vue?vue&type=template&id=ef7ef032&scoped=true&"
import script from "./fpFooter.vue?vue&type=script&lang=js&"
export * from "./fpFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7ef032",
  null
  
)

export default component.exports